import { render } from "./risks.vue?vue&type=template&id=48947020&scoped=true&ts=true"
import script from "./risks.vue?vue&type=script&lang=ts"
export * from "./risks.vue?vue&type=script&lang=ts"

import "./risks.vue?vue&type=style&index=0&id=48947020&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48947020"]])

export default __exports__